import { AutogenLayoutSalesStatusList } from "./autogen/AutogenLayoutSalesStatusList";

export class SalesStatusList extends AutogenLayoutSalesStatusList {
    onLoad(): void | Promise<void> {
        this.tableStatuses.addButtonCaption = "Add Sales Status";
    }
}